import { Injectable } from "@angular/core";
import { CellRendererItem } from "../data-grid/cell-renderer-item";
import { DefaultGridRendererProvider } from "../data-grid/default-grid-renderer-provider";
import { HeaderRendererItem } from "../data-grid/header-renderer-item";
import { TrainingDataCellRendererComponent } from "./training-data-cell-renderer.component";
import { TrainingDataHeaderRendererComponent } from "./training-data-header-renderer.component";

@Injectable({ providedIn: "root" })
export class TrainingDataGridRendererService extends DefaultGridRendererProvider {
  private renderer: HeaderRendererItem = new HeaderRendererItem(TrainingDataHeaderRendererComponent);
  private trainingDataCellRenderer: CellRendererItem = new CellRendererItem(TrainingDataCellRendererComponent);

  public override getRowNumberHeaderRenderer(): HeaderRendererItem {
    return this.renderer;
  }

  override getHeaderRenderer(colId: string) {
    return this.renderer;
  }

  override getCellRenderer(colId: string): CellRendererItem {
    return this.trainingDataCellRenderer;
  }
}
